export default __webpack_public_path__ + "static/3-d0b988935e08e6572c64c770a4479f10.png";